import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function HeroSection() {
  return <section id="inicio" className="relative bg-[#5a4579] text-white min-h-screen lg:min-h-[90vh] flex items-center pt-20 pb-8 lg:pt-20 lg:pb-0 overflow-hidden" data-id="element-231">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-232">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-233">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="max-w-2xl text-center lg:text-left" data-id="element-234">
            {/* Micro-badges */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-0 mb-6" data-id="element-235">
              <motion.span initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.6
            }} className="border border-[#C9A84C] text-white text-[10px] md:text-xs font-medium uppercase tracking-[0.15em] px-4 py-1.5 rounded-full" data-id="element-236">
                Tienes la&nbsp;idea
              </motion.span>
              <motion.span initial={{
              opacity: 0,
              scaleX: 0
            }} animate={{
              opacity: 1,
              scaleX: 1
            }} transition={{
              duration: 0.4,
              delay: 1.0
            }} className="w-px h-4 sm:w-6 sm:h-px bg-[#C9A84C]/60" data-id="element-237"></motion.span>
              <motion.span initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 1.2
            }} className="border border-[#C9A84C] text-white text-[10px] md:text-xs font-medium uppercase tracking-[0.15em] px-4 py-1.5 rounded-full" data-id="element-238">
                Crees en&nbsp;ella
              </motion.span>
              <motion.span initial={{
              opacity: 0,
              scaleX: 0
            }} animate={{
              opacity: 1,
              scaleX: 1
            }} transition={{
              duration: 0.4,
              delay: 1.6
            }} className="w-px h-4 sm:w-6 sm:h-px bg-[#C9A84C]/60" data-id="element-239"></motion.span>
              <motion.span initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 1.8
            }} className="border border-[#C9A84C] text-white text-[10px] md:text-xs font-medium uppercase tracking-[0.15em] px-4 py-1.5 rounded-full" data-id="element-240">
                La hacemos&nbsp;realidad
              </motion.span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-white font-serif" data-id="element-241">
              No basta con crear tu empresa: tu negocio también debe
              verse&nbsp;formal
            </h1>

            <p className="text-sm sm:text-base md:text-lg text-gray-300 mb-8 lg:mb-10 leading-relaxed max-w-xl mx-auto lg:mx-0 font-sans font-light" data-id="element-242">
              Te ayudamos a crear tu empresa en Florida y construir una
              presencia profesional para que tu negocio genere más confianza con
              clientes, aliados y entidades&nbsp;bancarias.
            </p>

            {/* Bullets */}
            <div className="flex flex-col gap-3 mb-8 items-center lg:items-start" data-id="element-243">
              {['Constitución de empresa en Florida', 'Presencia digital profesional', 'Acompañamiento claro en español'].map((item, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -10
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.4,
              delay: 0.8 + i * 0.15
            }} className="flex items-center gap-2.5" data-id="element-244">
                  <CheckCircleIcon className="w-5 h-5 text-inkova-accent flex-shrink-0" data-id="element-245" />
                  <span className="text-sm sm:text-base text-gray-200 font-sans" data-id="element-246">
                    {item}
                  </span>
                </motion.div>)}
            </div>

            <div className="flex flex-col items-center lg:items-start gap-4" data-id="element-247">
              <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-248">
                <a href="https://wa.me/17863037695?text=Hola%20Inkova%20%F0%9F%91%8B%20quiero%20crear%20mi%20empresa%20en%20EE.UU.%20y%20me%20gustar%C3%ADa%20recibir%20asesor%C3%ADa.%20%C2%BFMe%20puedes%20orientar?" target="_blank" rel="noopener noreferrer" className="inline-flex justify-center items-center px-8 py-4 rounded-full border-2 border-inkova-accent text-inkova-accent font-semibold text-base sm:text-lg hover:bg-inkova-accent hover:text-inkova-primary transition-colors duration-300 w-full sm:w-auto" data-id="element-249">
                  Crear mi empresa
                </a>
                <a href="#planes" className="inline-flex justify-center items-center px-8 py-4 rounded-full border-2 border-inkova-accent text-inkova-accent font-semibold text-base sm:text-lg hover:bg-inkova-accent hover:text-inkova-primary transition-colors duration-300 w-full sm:w-auto" data-id="element-250">
                  Ver planes
                </a>
              </div>
              <p className="text-sm text-gray-300 mt-2" data-id="element-251">
                ¿Tienes dudas primero?{' '}
                <a href="https://wa.me/17863037695" target="_blank" rel="noopener noreferrer" className="text-inkova-accent hover:underline font-medium" data-id="element-252">
                  Escríbenos por WhatsApp →
                </a>
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.4
        }} className="flex items-center justify-center order-first lg:order-last" data-id="element-253">
            <img src="https://cdn.magicpatterns.com/uploads/92Zgbj9dykCv9maWxyCKmk/INK_PNG.png" alt="Inkova — Business Consulting & Creation" className="w-full max-w-md lg:max-w-lg h-auto object-contain" data-id="element-254" />
          </motion.div>
        </div>
      </div>
    </section>;
}